export enum DRREnums {
  Records,
  ExportToExcelClick,
  FilterClick,
  SearchClick,
}
